const LEVEL_CONSOLE_MAP = {
    INFO: 'log',
    WARN: 'warn',
    ERROR: 'error'
};
const LEVEL_STYLE_MAP = {
    INFO: 'color:#FFF;background:cyan',
    WARN: 'color:#FFF;background:yellow',
    ERROR: 'color:#FFF;background:red'
};

function debug(moduleName, level, desc, data) {
    if (typeof window !== 'undefined' && typeof console !== 'undefined') {
        // eslint-disable-next-line no-console
        console[
            LEVEL_CONSOLE_MAP[level.toUpperCase()] || LEVEL_CONSOLE_MAP.INFO
        ](
            `%c %s %s %c %s. ${typeof data === 'object' ? '%O' : '%s'}`,
            LEVEL_STYLE_MAP[level.toUpperCase()] || LEVEL_STYLE_MAP.INFO,
            level,
            moduleName,
            'color:initial',
            desc,
            data || ''
        );
    }
}

function info(moduleName, desc, data) {
    debug(moduleName, 'log', desc, data);
}

function warn(moduleName, desc, data) {
    debug(moduleName, 'warn', desc, data);
}

function error(moduleName, desc, data) {
    debug(moduleName, 'error', desc, data);
}

export default {
    info,
    warn,
    error
};
